module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<dl class=\'stepped zero\'>\n    <dt>ID</dt>\n    <dd>' +
((__t = ( id )) == null ? '' : __t) +
'</dd>\n    <dt>' +
((__t = ( i18next.t('common.name') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( name )) == null ? '' : __t) +
'</dd>\n    <dt>' +
((__t = ( i18next.t('common.state') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( i18next.t(`glossary.${state}`).capitalize() )) == null ? '' : __t) +
'</dd>\n    ';
 if (showAccessToken) { ;
__p += '\n        <dt>' +
((__t = ( i18next.t('glossary.token') )) == null ? '' : __t) +
'</dt>\n        <dd>\n            ';
 if (fetchingAccessToken) { ;
__p += '\n                <i class=\'far fa-spinner fa-spin\'></i>\n            ';
 } else { ;
__p += '\n                ' +
((__t = ( access_token || '-' )) == null ? '' : __t) +
'\n            ';
 } ;
__p += '\n        </dd>\n    ';
 } ;
__p += '\n    <dt>' +
((__t = ( i18next.t('common.creation') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( WiseMetering.utils.formatDate(created_at) )) == null ? '' : __t) +
' - ' +
((__t = ( creator_name )) == null ? '' : __t) +
'</dd>\n    <dt>' +
((__t = ( i18next.t('glossary.last_change') )) == null ? '' : __t) +
'</dt>\n    <dd>' +
((__t = ( WiseMetering.utils.formatDate(updated_at) )) == null ? '' : __t) +
' - ' +
((__t = ( updater_name )) == null ? '' : __t) +
'</dd>\n</dl>\n';

}
return __p
}